var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BsModal',{attrs:{"title":_vm.title},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }